module.exports = __webpack_public_path__ + "static/media/sRuleCrt2.3149c149.png";